import {
    HIDE_ITEM_LOADER,
    SHOW_ITEM_LOADER,
    PUT_ITEM_DATA,
    FINDED_ITEM_DATA,
    ITEM_COMPARE_REMOVED_DATA,
    ITEM_COMPARE_ADDED_DATA,
    ACTION_MINUS_CART_COUNT,
    ACTION_PLUS_CART_COUNT, 
    CLEAR_COUNT_ADD_TO_CART,
    ITEM_UPDATE_COUNT
} from "../actions/item";

const initialState = {
    item: {},
    isFinded: false,
    showItemLoader: true,
    triggeredObject: [],
    urlForChange: null,
    wishList: [],
    compareList: [],
    countProductsToAdd: 1
};

export default function getsItemData(state = initialState, action) {
    switch (action.type) {

        case PUT_ITEM_DATA:
            return {
                ...state,
                item: action.item,
                showItemLoader: false,
                isFinded: false,
                isChangeUrl: false,
                urlForChange: null,
                wishList: action.item.wishList,
                compareList: action.item.compareList,
                countProductsToAdd: 1
            }
            break;

        case HIDE_ITEM_LOADER:
            return {
                ...state,
                showItemLoader: false
            }
            break;

        case FINDED_ITEM_DATA:
            return {
                ...state,
                item: action.item,
                isFinded: action.isFinded,
                triggeredObject: action.triggeredObject,
                isChangeUrl: action.isChangeUrl,
                urlForChange: action.urlForChange,
                countProductsToAdd: 1
            }
            break; 

        case SHOW_ITEM_LOADER:
            return {
                ...state,
                showItemLoader: true
            }
            break;

        case CLEAR_COUNT_ADD_TO_CART:
            return {
                ...state,
                countProductsToAdd: 1
            }
            break;

        case ITEM_COMPARE_REMOVED_DATA:
            return {
                ...state,
                wishList: state.wishList.filter(elem => elem !== parseInt(action.id))
            }
            break;

        case ITEM_COMPARE_ADDED_DATA:
            return {
                ...state,
                wishList: state.wishList.concat(parseInt(action.id))
            }
            break;

        case ACTION_MINUS_CART_COUNT:
            return {
                ...state,
                countProductsToAdd: state.countProductsToAdd > 1 ? state.countProductsToAdd - 1 : 1
            }
            break;

        case ACTION_PLUS_CART_COUNT:
            return {
                ...state,
                countProductsToAdd: state.countProductsToAdd + 1
            }
            break;

        case ITEM_UPDATE_COUNT:
            return{
                ...state,
                countProductsToAdd: action.count
            }
            break
        default:
            return state;
    }


}